
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

// @components
import Checkbox from '@/common/components/UI/Checkbox/index.vue'

// @types
import type { TimeSlotZone } from '@/new-services/types/time-slot-zones'

export default defineComponent({
    components: {
        Checkbox
    },
    props: {
        sector: {
            type: Object as PropType<TimeSlotZone>,
            required: true,
        },
        checked: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['click'],
    setup(props, { emit }) {
        const onClick = () => {
            if (props.disabled) return
            emit('click', {...props.sector})
        }

        return {
            onClick
        }
    }
})
